import { Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TransferTrackingDetailsCont = ({ children }) => {
	const theme = useTheme();
	const { t } = useTranslation();

	return (
		<>
			<Grid
				container
				sx={{
					pb: { xs: '0px', sm: '60px' },
					justifyContent: 'center'
				}}>
				<Grid item sx={{ width: { xs: '100%', sm: '90%', lg: '70%' } }}>
					<Grid
						container
						sx={{
							backgroundColor: 'white',
							minHeight: 275,
							borderRadius: { xs: '20px 20px 0px 0px', sm: '20px' },
							padding: '30px'
						}}>
						<Grid item xs={12} sx={{ textAlign: 'center' }}>
							<Typography variant="h3" color={theme.text.secondary} sx={{ fontWeight: '600' }}>
								{t('TRACK_TRANSFER')}
							</Typography>
						</Grid>
						<Grid item xs={12}>
							{children}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default TransferTrackingDetailsCont;
